import React from 'react';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';
import { SubscriptionExpiredBanner } from './SubscriptionExpiredBanner';
import { Portal } from '../types';
import { MyStore } from '../hooks/useMyStore';

interface LayoutProps {
  children: React.ReactNode;
  portal: Portal;
  currentPage: string;
  onNavigate: (page: string) => void;
  setupComplete: boolean;
  title?: string;
  subtitle?: string;
  store?: MyStore | null;
}

export const Layout: React.FC<LayoutProps> = ({
  children,
  portal,
  currentPage,
  onNavigate,
  setupComplete,
  title,
  subtitle,
  store,
}) => {
  return (
    <div className="flex h-screen overflow-hidden bg-bg">
      <aside className="w-[248px] shrink-0 h-screen overflow-hidden bg-sidebar flex flex-col relative z-30">
        <Sidebar
          portal={portal}
          currentPage={currentPage}
          onNavigate={onNavigate}
          setupComplete={setupComplete}
          store={store}
        />
      </aside>
      <div className="flex-1 min-w-0 flex flex-col h-screen overflow-hidden">
        <TopBar
          portal={portal}
          onNavigate={onNavigate}
          title={title}
          subtitle={subtitle}
          store={store}
        />
        <SubscriptionExpiredBanner
          store={store ?? null}
          portal={portal}
          currentPage={currentPage}
          onNavigate={onNavigate}
        />
        <main className="flex-1 p-6 overflow-y-auto">{children}</main>
      </div>
    </div>
  );
};
